import React from 'react';

import { Stack, Typography } from '@mui/material';

import HiddenApprovedFooter from '../../reportCards/HiddenApprovedFooter';
import ReportCard from '../../reportCards/ReportCard';
import type { ManualOverrideState } from '../../types';

import RoomCard from './RoomCard';
import UnlinkedDealOptionsCard from './UnlinkedDealOptionsCard';
import type { RoomRowView, UnlinkedDealOptionView } from './types';

interface Props {
  expandedRows: Record<string, boolean>;
  hiddenApprovedCount: number;
  manualOverrides: ManualOverrideState;
  rows: Array<RoomRowView>;
  showAutoApproved: boolean;
  unlinkedDealOptions: Array<UnlinkedDealOptionView>;
  onApprovalChange: (rowId: string) => void;
  onToggleDetails: (rowId: string, defaultOpen?: boolean) => void;
  onUnapprovalChange: (rowId: string) => void;
}

export default function RoomsReportCard({
  expandedRows,
  hiddenApprovedCount,
  manualOverrides,
  rows,
  showAutoApproved,
  unlinkedDealOptions,
  onApprovalChange,
  onToggleDetails,
  onUnapprovalChange,
}: Props) {
  return (
    <ReportCard bordered={false}>
      <Stack spacing={2} sx={{ pb: 2 }}>
        {rows.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
            No rooms match this view.
          </Typography>
        ) : (
          rows.map((room) => (
            <RoomCard
              key={room.id}
              expanded={expandedRows[room.id] ?? true}
              manualOverrides={manualOverrides}
              room={room}
              onApprovalChange={onApprovalChange}
              onToggleDetails={onToggleDetails}
              onUnapprovalChange={onUnapprovalChange}
            />
          ))
        )}

        <UnlinkedDealOptionsCard dealOptions={unlinkedDealOptions} />
      </Stack>

      <HiddenApprovedFooter count={hiddenApprovedCount} noun="room" showAutoApproved={showAutoApproved} />
    </ReportCard>
  );
}
